import React from 'react';
import { Dropdown, Button } from 'antd';
import { BulbOutlined, BulbFilled, SettingOutlined } from '@ant-design/icons';
import { useTheme, THEME_MODES } from '../contexts/ThemeContext';

const ThemeSelector = () => {
  const { themeMode, changeThemeMode } = useTheme();

  const getIcon = () => {
    switch (themeMode) {
      case THEME_MODES.LIGHT:
        return <BulbFilled style={{ color: '#ffd700' }} />; // Gold/yellow for light mode
      case THEME_MODES.DARK:
        return <BulbOutlined style={{ color: '#87ceeb' }} />; // Light blue for dark mode
      case THEME_MODES.SYSTEM:
        return <SettingOutlined style={{ color: '#ffffff' }} />; // White for system
      default:
        return <BulbOutlined style={{ color: '#ffffff' }} />;
    }
  };

  const getLabel = () => {
    switch (themeMode) {
      case THEME_MODES.LIGHT:
        return 'Light';
      case THEME_MODES.DARK:
        return 'Dark';
      case THEME_MODES.SYSTEM:
        return 'System';
      default:
        return 'Light';
    }
  };

  const menuItems = [
    {
      key: THEME_MODES.LIGHT,
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <BulbFilled style={{ color: 'var(--warning-color)' }} />
          <span>Light</span>
          {themeMode === THEME_MODES.LIGHT && <span style={{ marginLeft: 'auto' }}>✓</span>}
        </div>
      ),
      onClick: () => changeThemeMode(THEME_MODES.LIGHT),
    },
    {
      key: THEME_MODES.DARK,
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <BulbOutlined style={{ color: 'var(--info-color)' }} />
          <span>Dark</span>
          {themeMode === THEME_MODES.DARK && <span style={{ marginLeft: 'auto' }}>✓</span>}
        </div>
      ),
      onClick: () => changeThemeMode(THEME_MODES.DARK),
    },
    {
      key: THEME_MODES.SYSTEM,
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <SettingOutlined style={{ color: 'var(--text-muted)' }} />
          <span>System</span>
          {themeMode === THEME_MODES.SYSTEM && <span style={{ marginLeft: 'auto' }}>✓</span>}
        </div>
      ),
      onClick: () => changeThemeMode(THEME_MODES.SYSTEM),
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button
        type="text"
        icon={getIcon()}
        style={{ 
          color: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}
      >
        {getLabel()}
      </Button>
    </Dropdown>
  );
};

export default ThemeSelector;

